<template>
    <section class="sub-footer text-center py-4" id="subFoter">
            <div class="container py-md-5">
                <h2 class="heading-2 mb-4"><span class="text-brand">Thousands </span>of Happy Marriages</h2>
                <router-link to="/membership-plans" class="btn btn-brand-1 mb-md-5 mb-3 px-5">View Membership</router-link>
                <p class="font-medium text-secondary font-18">This website only meant for users with a banafide intent to enter in to matrimonial alliance &amp; is not meant for users interested in dating only and this website should not be used to post an obscene</p>
            </div>
        </section>
</template>
<script>
export default {
  name: "SubFooterInner",
  data() {},
  mounted() {},
  methods: {},
};
</script>